import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Traductor from '../../Traductor';

const EditNameForm = ({ onCancel, onSubmit }) => {
    const t = new Traductor();
    const [inputValue, setInputValue] = useState('');

    return (
        <div className="u-ph u-pb">
            <header className="c-modal__header">
                <div className="c-modal__title__wrapper u-text-left">
                    <h1
                        className="c-modal__title"
                        id="details-modal-id"
                        style={{ alignSelf: 'flex-start' }}
                    >
                        {t.getTraduction('EditNameTitle')}
                    </h1>
                </div>
                <button
                    className="c-modal__close-btn  js-modal-close"
                    type="button"
                    aria-label="Close modal"
                    onClick={onCancel}
                />
            </header>
            <form className="" action="#">
                <div className="c-modal__content" role="document">
                    <div className="c-form-field  u-text-left">
                        <label
                            htmlFor="edit-name-input"
                            className="c-form-field__label"
                        >
                            {t.getTraduction('NewBatchName')}
                        </label>
                        <div className="c-form-field__box">
                            <div className="c-input  ">
                                <input
                                    onChange={e =>
                                        setInputValue(e.target.value)
                                    }
                                    value={inputValue}
                                    className="c-input__input  "
                                    id="edit-name-input"
                                    type="text"
                                    placeholder={t.getTraduction(
                                        'TrolleyFormNamePlaceholder'
                                    )}
                                    data-tr-component="Input Field"
                                    data-tr-function="Text Input"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="c-modal__footer">
                    <div className="c-modal__actions o-button-container">
                        <div className="c-modal__actions__item">
                            <button
                                className="c-btn  c-btn--secondary  js-modal-close  js-modal-autofocus"
                                aria-label="Close modal"
                                onClick={onCancel}
                            >
                                <span className="c-btn__text">
                                    {t.getTraduction('Cancelar')}
                                </span>
                            </button>
                        </div>
                        <div className="c-modal__actions__item">
                            <button
                                className="c-btn  js-modal-close  js-modal-autofocus"
                                aria-label="Close modal and confirm"
                                onClick={() => {
                                    onSubmit(inputValue);
                                    setInputValue('');
                                }}
                                disabled={!inputValue}
                            >
                                <span className="c-btn__text">
                                    {t.getTraduction('BtnGuardar')}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

EditNameForm.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default EditNameForm;
